<div class="card panel-flat mt-3">
  <div class="panel-heading">
    <h6 class="panel-title">10 Most Inactive Vendors</h6>
    <small class="text-muted"> Based on Max Number of Closed Industries </small>
  </div>
  <div class="table-responsive" style="height: 370px;">
    <table class="table text-nowrap">
      <thead>
      <tr>
        <th style="padding: 0px; padding-left: 10px;">S No.</th>
        <th style="padding: 0px; padding-left: 10px;">Vendor Name</th>

        <th class="text-center">Closed Ind</th>
        <th class="text-center">Total Ind</th>
        <th class="text-center" style="word-break: break-all;">Closed<br/>%age</th>
      </tr>
      </thead>
      <tbody *ngIf="!industryListLoader &&  industryList.length">
      <tr *ngFor="let industry of industryList let i = index" [attr.data-index]="i">
        <td style="padding: 0px; padding-left: 15px;">
          {{i+1}}
        </td>

        <td style="padding: 0px; padding-left: 10px;">

          <span title="{{industry.vendor_short_name}}" class="letter-icon-title">
            {{(industry.vendor_short_name && industry.vendor_short_name.length>15)? (industry.vendor_short_name | slice:0:15)+'...':(industry.vendor_short_name)}}
          </span>
        </td>
        <td style="text-align: center; color: red;">
          <h6 class="text-semibold no-margin">{{industry.total}}</h6>
        </td>

        <td style="text-align: center;">
          <h6 class="text-semibold no-margin">{{industry.total_industry}}</h6>
        </td>

        <td style="text-align: center; color: red;">
          <h6 class="text-semibold no-margin">{{industry.percentage}} %</h6>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="!industryListLoader && !industryList.length" >
      <tr>
        <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
          <div class="label label-danger" style="margin-top: 50px;">No Industry Found</div>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="industryListLoader" >
      <tr>
        <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
          <div style="margin-top: 50px;">
            <img src="/assets/images/load.gif" />
          </div>
        </td>
      </tr>
      </tbody>

    </table>
  </div>
</div>
